import React, { useState } from 'react';
import { Container, Typography, TextField, Button, Snackbar } from '@mui/material';
import './App.css';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import logo from './png/code_hive_logo2.jpg';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

console.log(firebaseConfig);


if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();

function App() {
  const [email, setEmail] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = () => {
    console.log("success")
    db.collection('waitlist').add({ email })
      .then(() => {
        setOpenSnackbar(true);
        setTimeout(() => {
          setOpenSnackbar(false);
        }, 5000);
      })
      .catch((error) => {
        console.error('Error adding document: ', error);
      });
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <Container className="container">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={logo} alt="Code Hive Logo" style={{ width: 100, height: 100, marginRight: 10 }} />
        <Typography variant="h3" gutterBottom>
          <b>Building the Future of Coders</b>
        </Typography>
      </div>
      <Typography variant="h4" gutterBottom>
        Code Hive Academy3X (CHA CHA CHA)
      </Typography>
      <Typography variant="body1" gutterBottom>
        Join the waitlist, and we will keep you posted on new updates!
      </Typography>
      <TextField
        label="Enter your email"
        variant="outlined"
        // fullWidth
        size = "small"
        value={email}
        onChange={handleEmailChange}
        style={{ marginBottom: '10px', marginRight: '10px' }}
      />
      <Button variant="contained" color="primary" onClick={handleSubmit}>
        Submit
      </Button>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        message="Please check your inbox... you are now on the waitlist!"
      />
  </Container>
  );
}

export default App;
